import Siema from 'siema';

export default {
	init() {
		// JavaScript to be fired on all pages
	},
	finalize() {
		// JavaScript to be fired on all pages, after page specific JS is fired
		if ($('.faq-holder').length) {
			$('.faq-slides').slick({
				arrows: false,
				dots: true,
			});
		}
		$.fn.isInViewport = function () {
			var elementTop = $(this).offset().top;
			var elementBottom = elementTop + $(this).outerHeight();
			var viewportTop = $(window).scrollTop();
			var viewportBottom = viewportTop + $(window).height();
			return elementBottom > viewportTop && elementTop < viewportBottom;
		};
		$.fn.pvisible = function () {
			var eTop = this.offset().top;
			var eBottom = eTop + this.height();
			var wTop = $(window).scrollTop();
			var wBottom = wTop + $(window).height();
			var totalH = Math.max(eBottom, wBottom) - Math.min(eTop, wTop);
			var wComp = totalH - $(window).height();
			var eIn = this.height() - wComp;
			return eIn <= 0 ? 0 : (eIn / this.height()) * 100;
		};

		$(window).on('scroll', function () {
			if ($('.top-footer').isInViewport()) {
				$('.contact-button').fadeOut();
			} else {
				$('.contact-button').fadeIn();
			}
		});

		if ($('#blobSvg').length) {
			var svg = document.getElementById('blobSvg');
			var s = Snap(svg);

			var blob1 = Snap.select('#blob1');
			var blob2 = Snap.select('#blob2');
			var blob3 = Snap.select('#blob3');
			var blob4 = Snap.select('#blob4');

			var blob1Points = blob1.node.getAttribute('d');
			var blob2Points = blob2.node.getAttribute('d');
			var blob3Points = blob3.node.getAttribute('d');
			var blob4Points = blob4.node.getAttribute('d');

			var toBlob4 = function () {
				blob1.animate({ d: blob4Points }, 1000, mina.linear, toBlob1);
			};

			var toBlob3 = function () {
				blob1.animate({ d: blob3Points }, 1000, mina.linear, toBlob4);
			};

			var toBlob2 = function () {
				blob1.animate({ d: blob2Points }, 1000, mina.linear, toBlob3);
			};

			var toBlob1 = function () {
				blob1.animate({ d: blob1Points }, 1000, mina.linear, toBlob2);
			};

			toBlob1();
		}

		$('#burger').on('click', function(e) {
			e.preventDefault(),
				$('.mobile-menu').toggleClass('mobile-menu--open')
		})

		// Toggle submenu visibility when clicking the +/- indicator
		$('.mobile-menu .menu-item-has-children > a').on('click', function(e) {
			// Only prevent default if clicking on the +/- indicator
			const $parent = $(this).parent();
			const clickX = e.pageX - $(this).offset().left;
			const width = $(this).outerWidth();

			// If click is in the rightmost 30px (where the +/- indicator is)
			if (clickX > (width * 0.5 ) ) {
				e.preventDefault();
				$parent.toggleClass('submenu-open');
				$parent.children('.sub-menu').toggleClass('open');
			}
			// Otherwise, let the link work normally for navigation
		})
	},
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js